<template>
  <div>
    <woot-button
      v-if="canAddAgent"
      color-scheme=""
      class="button-filled"
      icon="add"
      @click="openAddPopup()"
    >
      {{ $t('AGENT_MGMT.HEADER_BTN_TXT') }}
    </woot-button>
    <!-- Add Agent -->
    <woot-modal
      :show.sync="showAddPopup"
      :on-close="hideAddPopup"
      class="add-agent-modal"
    >
      <add-agent :on-close="hideAddPopup" />
    </woot-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import AddAgent from './AddAgent.vue';

export default {
  components: { AddAgent },
  mixins: [globalConfigMixin, hasPermissionMixin],
  data() {
    return {
      loading: {},
      showAddPopup: false,
      agentAPI: {
        message: '',
      },
      currentAgent: {},
    };
  },
  computed: {
    ...mapGetters({
      features: 'getCurrentFeatures',
    }),
    // Platform accounts without the full_settings flag manage agents through the
    // partner API, so the dashboard list stays read-only.
    online99PlatformsCanManageAgents() {
      return this.features?.full_settings !== false;
    },
    canAddAgent() {
      return (
        this.hasCreatePermission('Agents') &&
        this.online99PlatformsCanManageAgents
      );
    },
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
  },
};
</script>
